import {AppSettingApi} from '../AppSettingApi';
import {BaseWebApiDAO} from './BaseWebApiDAO';
import {ReservationDTOInterface} from '../DTO/ReservationDTOInterface';
import {ReservationSaveDTOInterface} from '../DTO/ReservationSaveDTOInterface';
import {toCamel} from '../Util/SnakeCamelUtil';
import {MstDepartmentDTOInterface} from '../DTO/MstDepartmentDTOInterface';
import {MstClinicDTOInterface} from '../DTO/MstClinicDTOInterface';
import {ReservationDetailDTOInterface} from '../DTO/ReservationDetailDTOInterface';
import {UserSearchResultDTOInterface} from '../DTO/UserSearchResultDTOInterface';
import {MstDoctorDTOInterface} from '../DTO/MstDoctorDTOInterface';
import {ReservationFrameDTOInterface} from '../DTO/ReservationFrameDTOInterface';
import {MstExaminationDTOInterface} from '../DTO/MstExaminationDTOInterface';
import {DepartmentListDTOInterface} from '../DTO/DepartmentListDTOInterface';
import {DeviceTypeDTOInterface} from '../DTO/DeviceTypeDTOInterface';
import {ReserveAlertListDTOInterface} from '../DTO/ReserveAlertListDTOInterface';
import {ReservationOnlineAgreementInsureDTOInterface} from '../DTO/ReservationOnlineAgreementInsureDTOInterface';
import {ReservationUserLimitErrorDTOInterface} from '../DTO/ReservationUserLimitErrorDTOInterface';

/**
 * 予約データDAO
 */
export class ReservationDAO extends BaseWebApiDAO {

	/**
	 * ログインユーザーの予約一覧の取得
	 */
	public async getReservationList(): Promise<any> {
		const request = {
			t: this.token
		};

		const ret = await this.postRequest(AppSettingApi.RESERVATION_LIST, request);
		return ret;
	}

	/**
	 * 予約詳細画面のデータ取得
	 * @param reservationId
	 */
	public async getReserveDetailViewData(reservationId: number): Promise<any> {
		this.log('ReservationDao::getReserveDetailViewData()');
		const request = {
			t: this.token,
			reservation_id: reservationId
		};
		this.log(AppSettingApi.RESERVATION_GET_DETAIL_VIEW_DATA);
		this.log(request);

		const ret = await this.postRequest(AppSettingApi.RESERVATION_GET_DETAIL_VIEW_DATA, request);

		this.log(ret);

		return ret;
	}

	/**
	 * 一時保存した予約を取得する
	 * @param token
	 */
	public async getTmpReserve(token: string): Promise<any> {
		const request = {
			t: this.token,
			reserve_token: token
		};

		return await this.postRequest(AppSettingApi.RESERVATION_GET_TMP_RESERVE, request);
	}

	/**
	 * 一時保存した予約の削除
	 * @param token
	 */
	public async deleteTmpReserve(token: string): Promise<any> {
		const request = {
			t: this.token,
			reserve_token: token
		};

		return await this.postRequest(AppSettingApi.RESERVATION_DELETE_TMP_RESERVE, request);
	}

	/**
	 * ユーザーなし予約作成
	 * @param data
	 */
	public async createReservationByAnonymous(data: ReservationSaveDTOInterface): Promise<{token: string}> {

		const request = {
			clinic_id: data.clinicId,
			doctor_id: data.doctorId,
			department_id: data.departmentId,
			reservation_date: data.reservationDate,
			reservation_from: data.reservationFrom,
			reservation_to: data.reservationTo,
			exam: data.examList,
			appointment_type: data.appointmentType,
			visit_type: data.visitType,
			memo_user: data.memoUser,
		};

		const ret = await this.postRequest(AppSettingApi.RESERVATION_CREATE, request);

		return ret;
	}

	/**
	 * ログインユーザーでの予約作成
	 * @param data
	 * @param onlineAgreement
	 */
	public async createReservationByUser(
		data: ReservationSaveDTOInterface,
		onlineAgreement: ReservationOnlineAgreementInsureDTOInterface
	): Promise<ReservationDetailDTOInterface|ReservationUserLimitErrorDTOInterface> {

		this.log('ReservationDAO::createReservationByUser()');
		const request = {
			t: this.token,
			clinic_id: data.clinicId,
			doctor_id: data.doctorId,
			department_id: data.departmentId,
			reservation_date: data.reservationDate,
			reservation_from: data.reservationFrom,
			reservation_to: data.reservationTo,
			exam: data.examList,
			appointment_type: data.appointmentType,
			visit_type: data.visitType,
			memo_user: data.memoUser,
			agreement: onlineAgreement.agreement,
			agreement_date: onlineAgreement.agreementDate
		};
		this.log(request);
		const ret = await this.postRequest(AppSettingApi.RESERVATION_CREATE_BY_USER, request);
		this.log(ret);

		if (!ret) {
			return ret;
		}

		if (ret.hasOwnProperty('type')) {
			const examList = this.obj2Array(toCamel(ret.exam_list));
			const error: ReservationUserLimitErrorDTOInterface = toCamel(ret) as ReservationUserLimitErrorDTOInterface;
			error.examList = examList;
			return error;
		} else {
			const reserve: ReservationDetailDTOInterface = {
				reservation: toCamel(ret.reservation) as ReservationDTOInterface,
				user: toCamel(ret.user) as UserSearchResultDTOInterface,
				mstClinic: toCamel(ret.mst_clinic) as MstClinicDTOInterface,
				mstDepartment: toCamel(ret.mst_department) as MstDepartmentDTOInterface,
				mstDoctor: toCamel(ret.mst_doctor) as MstDoctorDTOInterface,
				mstExamination: this.obj2Array(toCamel(ret.mst_examination)) as Array<MstExaminationDTOInterface>,
				interview: this.obj2Array(toCamel(ret.interview))
			};

			return reserve;
		}

	}


	/**
	 * 予約更新
	 * @param data
	 * @param onlineAgreement
	 */
	public async updateReservation(
		data: ReservationSaveDTOInterface,
		onlineAgreement: ReservationOnlineAgreementInsureDTOInterface
	): Promise<ReservationDetailDTOInterface|ReservationUserLimitErrorDTOInterface> {

		this.log('ReservationDAO::updateReservation()');
		this.log(data);
		const request = {
			t: this.token,
			id: data.id,
			doctor_id: data.doctorId,
			department_id: data.departmentId,
			reservation_date: data.reservationDate,
			reservation_from: data.reservationFrom,
			reservation_to: data.reservationTo,
			appointment_type: data.appointmentType,
			exam: data.examList,
			visit_type: data.visitType,
			memo_user: data.memoUser,
			agreement: onlineAgreement.agreement,
			agreement_date: onlineAgreement.agreementDate
		};
		this.log(request);
		const ret = await this.postRequest(AppSettingApi.RESERVATION_UPDATE, request);


		if (ret.hasOwnProperty('type')) {
			const examList = this.obj2Array(toCamel(ret.exam_list));
			const error: ReservationUserLimitErrorDTOInterface = toCamel(ret) as ReservationUserLimitErrorDTOInterface;
			error.examList = examList;
			return error;
		} else {
			const reserve: ReservationDetailDTOInterface = {
				reservation: toCamel(ret.reservation) as ReservationDTOInterface,
				user: toCamel(ret.user) as UserSearchResultDTOInterface,
				mstClinic: toCamel(ret.mst_clinic) as MstClinicDTOInterface,
				mstDepartment: toCamel(ret.mst_department) as MstDepartmentDTOInterface,
				mstDoctor: toCamel(ret.mst_doctor) as MstDoctorDTOInterface,
				mstExamination: this.obj2Array(toCamel(ret.mst_examination)) as Array<MstExaminationDTOInterface>,
				interview: this.obj2Array(toCamel(ret.interview))
			};

			return reserve;
		}
	}


	/**
	 * 予約キャンセル
	 * @param data
	 */
	public async cancelReservation(data: { reservationId: number }): Promise<ReservationDTOInterface> {
		const request = {
			t: this.token,
			reservation_id: data.reservationId
		};

		const ret = await this.postRequest(AppSettingApi.RESERVATION_CANCEL, request);

		return ret;
	}


	/**
	 * 更新ページ初期データ取得
	 * @param param
	 */
	public async getUpdateViewData(param: { reservationId: number }): Promise<{
		reservation: ReservationDetailDTOInterface;
		selectedClinicId: number;
		clinicList: Array<MstClinicDTOInterface>;
		departmentVisitList: Array<MstDepartmentDTOInterface>;
		departmentOnlineList: Array<MstDepartmentDTOInterface>;
		visitTypeList: Array<{id: number; name: string}>;
		appointmentTypeList: Array<{id: number; name: string}>;
		deviceTypeList: Array<DeviceTypeDTOInterface>;
		alertList: ReserveAlertListDTOInterface;
	}> {
		this.log('ReservationDao::getUpdateViewData()');

		const request = {
			t: this.token,
			reservation_id: param.reservationId
		};

		const res = await this.postRequest(AppSettingApi.RESERVATION_GET_UPDATE_VIEW_DATA, request);

		this.log(res);

		const departmentVisitList = [];
		for (const department of res.department_visit_list) {
			const examVisit = this.obj2Array(toCamel(department.mst_examination.visit));
			const examOnline = this.obj2Array(toCamel(department.mst_examination.online));

			const departmentData: any = toCamel(department);
			departmentData.mstExamination = {
				visit: examVisit,
				online: examOnline
			};
			departmentVisitList.push(departmentData);
		}

		const departmentOnlineList = [];
		for (const department of res.department_online_list) {
			const examVisit = this.obj2Array(toCamel(department.mst_examination.visit));
			const examOnline = this.obj2Array(toCamel(department.mst_examination.online));

			const departmentData: any = toCamel(department);
			departmentData.mstExamination = {
				visit: examVisit,
				online: examOnline
			};
			departmentOnlineList.push(departmentData);
		}

		const exam = res.reservation.reservation.exam.split(',');
		const reservationDetail: ReservationDetailDTOInterface = {
			reservation: toCamel(res.reservation.reservation) as ReservationDTOInterface,
			user: toCamel(res.reservation.user) as UserSearchResultDTOInterface,
			mstClinic: toCamel(res.reservation.mst_clinic) as MstClinicDTOInterface,
			mstDepartment: toCamel(res.reservation.mst_department) as MstDepartmentDTOInterface,
			mstDoctor: toCamel(res.reservation.mst_doctor) as MstDoctorDTOInterface,
			mstExamination: this.obj2Array(toCamel(res.mst_examination)) as Array<MstExaminationDTOInterface>,
			interview: this.obj2Array(toCamel(res.interview))
		};

		reservationDetail.reservation.exam = exam;

		const data = {
			reservation: reservationDetail,
			selectedClinicId: res.selected_clinic_id,
			clinicList: res.clinic_list,
			visitTypeList: res.visit_type_list,
			appointmentTypeList: res.appointment_type_list,
			departmentVisitList,
			departmentOnlineList,
			deviceTypeList: res.device_type_list,
			alertList: res.alert_list
		};

		return data;
	}

	/**
	 * 予約作成 開始画面のデータ取得
	 * @param clinicId
	 */
	public async getReserveStartViewData(clinicId: number): Promise<{
		selectedClinicId: number;
		clinicList: Array<MstClinicDTOInterface>;
		departmentVisitList: Array<DepartmentListDTOInterface>;
		departmentOnlineList: Array<DepartmentListDTOInterface>;
		visitTypeList: Array<{id: number; name: string}>;
		appointmentTypeList: Array<{id: number; name: string}>;
		deviceTypeList: Array<DeviceTypeDTOInterface>;
		alertList: ReserveAlertListDTOInterface;
	}> {
		this.log('ReservationDao::getReserveStartData()');
		const request = {
			clinic_id: clinicId
		};

		const res = await this.postRequest(AppSettingApi.RESERVATION_GET_START_VIEW_DATA, request);
		this.log(res);

		const departmentVisitList = [];
		for (const department of res.department_visit_list) {
			const examVisit = this.obj2Array(toCamel(department.mst_examination.visit));
			const examOnline = this.obj2Array(toCamel(department.mst_examination.online));

			const departmentData: any = toCamel(department);
			departmentData.mstExamination = {
				visit: examVisit,
				online: examOnline
			};
			departmentVisitList.push(departmentData);
		}

		const departmentOnlineList = [];
		for (const department of res.department_online_list) {
			const examVisit = this.obj2Array(toCamel(department.mst_examination.visit));
			const examOnline = this.obj2Array(toCamel(department.mst_examination.online));

			const departmentData: any = toCamel(department);
			departmentData.mstExamination = {
				visit: examVisit,
				online: examOnline
			};
			departmentOnlineList.push(departmentData);
		}

		const data = {
			selectedClinicId: res.selected_clinic_id,
			clinicList: res.clinic_list,
			visitTypeList: res.visit_type_list,
			appointmentTypeList: res.appointment_type_list,
			departmentVisitList,
			departmentOnlineList,
			deviceTypeList: res.device_type_list,
			alertList: res.alert_list
		};

		return data;
	}

	/**
	 * 予約作成時に表示する規約の取得
	 * @param reserve
	 */
	public async getAgreement(reserve: ReservationSaveDTOInterface): Promise<any> {
		const request = {
			clinic_id: reserve.clinicId,
			visit_type: reserve.visitType,
			appointment_type: reserve.appointmentType,
			department_id: reserve.departmentId,
			exam: reserve.examList
		};

		const res = await this.postRequest(AppSettingApi.RESERVATION_GET_AGREEMENT, request);

		return this.obj2Array(toCamel(res));
	}


	/**
	 * 予約日時選択画面のデータ取得
	 * @param param
	 */
	public async getReserveSelectDateViewData(param: {
		fromDate: string;
		toDate: string;
		departmentId: number;
		doctorId: number;
		appointmentType: string;
		visitType: string;
		examList: Array<any>;
	}): Promise<{
		data: ReservationFrameDTOInterface;
		doctorList: Array<MstDoctorDTOInterface>;
	}> {

		this.log('ReservationDAO::getReserveSelectDateViewData()');
		const request = {
			doctor_id: param.doctorId,
			department_id: param.departmentId,
			from_date: param.fromDate,
			to_date: param.toDate,
			appointment_type: param.appointmentType,
			visit_type: param.visitType,
			exam: param.examList
		};

		this.log(request);

		const res = await this.postRequest(AppSettingApi.RESERVATION_GET_SELECT_DATE_VIEW_DATA, request);

		this.log(res);

		return {
			data: res.reservation_slot.data,
			doctorList: res.doctor_list
		};
	}


	/**
	 * 予約完了メッセージの送信
	 * @param reservationId
	 */
	public async sendReserveCompleteMessage(reservationId: number): Promise<any> {
		this.log('ReservationDAO::sendReserveCompleteMessage()');
		const request = {
			t: this.token,
			reservation_id: reservationId
		};
		this.log(request);

		const ret = await this.postRequest(AppSettingApi.RESERVATION_SEND_COMPLETE_MESSAGE, request);

		return ret;
	}

	/**
	 * 予約更新メッセージの送信
	 * @param reservationId
	 */
	public async sendReserveUpdateMessage(reservationId: number): Promise<any> {
		this.log('ReservationDAO::sendReserveUpdateMessage()');
		const request = {
			t: this.token,
			reservation_id: reservationId
		};
		this.log(request);

		const ret = await this.postRequest(AppSettingApi.RESERVATION_SEND_UPDATE_MESSAGE, request);

		return ret;
	}

	/**
	 * 予約キャンセルメッセージの送信
	 * @param reservationId
	 */
	public async sendReserveCancelMessage(reservationId: number): Promise<any> {
		this.log('ReservationDAO::sendReserveCancelMessage()');
		const request = {
			t: this.token,
			reservation_id: reservationId
		};
		this.log(request);

		const ret = await this.postRequest(AppSettingApi.RESERVATION_SEND_CANCEL_MESSAGE, request);

		return ret;
	}

	/**
	 * 保険外負担に関する同意書への同意
	 * @param token
	 */
	public async agreementNoneInsure(token: string): Promise<any> {
		this.log('ReservationDAO::agreementNoneInsure()');
		const request = {
			t: this.token,
			token
		};
		this.log(AppSettingApi.RESERVATION_AGREEMENT_NONE_INSURE);
		this.log(request);

		const ret = await this.postRequest(AppSettingApi.RESERVATION_AGREEMENT_NONE_INSURE, request);

		this.log(ret);

		return ret;
	}

	/**
	 * 保険外負担に関する同意書の表示
	 * @param token
	 */
	public async getOnlineAgreementInsure(token: string): Promise<any> {
		this.log('ReservationDAO::getOnlineAgreementInsure()');
		const request = {
			t: this.token,
			token
		};
		this.log(AppSettingApi.RESERVATION_GET_ONLINE_AGREEMENT);
		this.log(request);

		const ret = await this.postRequest(AppSettingApi.RESERVATION_GET_ONLINE_AGREEMENT, request);

		this.log(ret);

		return ret;
	}
}
